import { createContext } from 'react'
import { GroupChannel } from '@sendbird/chat/groupChannel'

export enum ChatStatusType {
  NOT_INITIALAZED = 'not-initialized',
  INITIALIZING = 'initializing',
  INITIALIZED = 'initialized',
  FAILED = 'failed',
}

export type ChatStoreState = {
  connectionChannelsUnreadMessagesCount: number
  connectionRequestChannelsUnreadMessagesCount: number
  dealChannelsUnreadMessagesCount: number
  hasUnreadMessages: boolean
  activeChannel: GroupChannel | null
  status: ChatStatusType
}

export const ChatStoreContext = createContext({} as ChatStoreState)
